<div class="risk-card" data-cy="portfolio-risk-chart">
	<h3 class="title">{{ displayTitle }}</h3>

	<!-- Loading skeleton -->
	<ng-container *ngIf="loading; else dataOrEmptyTemplate">
		<div class="chart-skeleton">
			<p-skeleton width="100%" height="500px"></p-skeleton>
		</div>
	</ng-container>

	<ng-template #dataOrEmptyTemplate>
		<ng-container *ngIf="hasData; else emptyStateTemplate">
			<p-chart
				[data]="chartData"
				[options]="chartOptions"
				style="width: 100%; height: 300px"
				type="line"
			></p-chart>
		</ng-container>
	</ng-template>

	<ng-template #emptyStateTemplate>
		<div *ngIf="!loading" class="flex bg-white justify-content-center my-5 custom-card">
			<div class="bg-blue-50 p-3 text-center rounded text-gray-800">
				{{
					errorStatus === 403
						? 'No AI enabled tasks available'
						: 'No data available for the selected date range'
				}}
				<div class="pt-1">
					<a
						href="mailto:support@tyalls.com"
						*ngIf="errorStatus === 403"
						class="text-primary cursor-pointer ml-1"
					>
						To enable AI Tasks contact support&#64;tyalls.com
					</a>
				</div>
			</div>
		</div>
	</ng-template>
</div>
